import api from 'api'
import { CompanyTypeValue, companyTypeToFields } from './companyType'

type CreateCompanyRequest = {
  companyName: string
  type: CompanyTypeValue
}

export const createCompany = async (request: CreateCompanyRequest) => {
  const { type, requiresEverify } = companyTypeToFields(request.type)
  const response = await api.post(`/admin/company/create`, {
    company_name: request.companyName,
    type,
    requires_everify: requiresEverify,
  })
  return response.data
}
